	import {  ChangeLogService, BaseTLDetailComponent, AxiosResponse, tlResponseDateToFormDateTimeString } from "../../../Infrastructure/CorBase/CoreBase";

	export default abstract class ChangeLogDetailBase extends BaseTLDetailComponent {
		returnRoute: string = "ChangeLogList";
		changeLogService: ChangeLogService = new ChangeLogService();

		formData = {
			id: 0,
			idChangeObject: 0,
			idObjectTypeNavigationName: '',
			idChangeTypeNavigationName: '',
			idObjectTypeNavigationIdentifier: '',
			description: '',
			idWhoConfirmed: 0,
			idWhoChanged: 0,
			idWhoChangedNavigationLogin: '',
			idWhoConfirmedNavigationLogin: '',
			whenChanged: '',
			whenConfirmed: '',
			mustBeConfirmed: false,
			isConfirmed: false,
			isDeleted: false
		};



		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.changeLogService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
					this.formData.id = response.data.id;
					this.formData.idChangeObject = response.data.idChangeObject;
					this.formData.idObjectTypeNavigationName = response.data.idObjectTypeNavigationName;
					this.formData.idObjectTypeNavigationIdentifier = response.data.idObjectTypeNavigationIdentifier;
					this.formData.idChangeTypeNavigationName = response.data.idChangeTypeNavigationName;
					this.formData.description = response.data.description;
					this.formData.idWhoConfirmed = response.data.idWhoConfirmed;
					this.formData.idWhoChanged = response.data.idWhoChanged;
					this.formData.idWhoChangedNavigationLogin = response.data.idWhoChangedNavigationLogin;
					this.formData.idWhoConfirmedNavigationLogin = response.data.idWhoConfirmedNavigationLogin;
					this.formData.whenChanged = tlResponseDateToFormDateTimeString(response.data.whenChanged);
					this.formData.whenConfirmed = tlResponseDateToFormDateTimeString(response.data.whenConfirmed);
					this.formData.mustBeConfirmed = response.data.mustBeConfirmed;
					this.formData.isDeleted = response.data.isDeleted;
			this.formData.isConfirmed = response.data.isConfirmed;	
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			return this.changeLogService.update(this.objectId, this.formData)
		}

		showConfirmedBase() {
			return this.formData.mustBeConfirmed;
			// this.formData.idObjectTypeNavigationIdentifier != "ENU_COR_ChangeLog_ObjectType_Content";// && this.formData.idObjectTypeNavigationIdentifier != "ENU_COR_ChangeLog_ObjectType_Task";
        }

		doAction() {
			super.doCRUDActionWithInfoMessage('', this.$t('changeLog.messageEdit').toString(), '');
		}

		showConfirmChangeLogButton() {
			return this.styleFormDetail && this.formData.isConfirmed == false && this.formData.mustBeConfirmed;
		}

		confirmChangeLog() {
			super.callActionAndShowErrorInfoMessage(this.changeLogService.confirm(this.getConfirmChangeLogData()), this.$t('changeLog.messageConfirmed').toString());
		}

		getConfirmChangeLogData() {
			return { id: this.objectId, idUser: this.$store.state.idUser };
		}

		validate() {
			return !(true);
		}

		get showWhoConfirmed(): boolean {
			if (this.formData.idWhoConfirmedNavigationLogin) {
				return true;
			}
			return false;
		}

		get showWhoChanged(): boolean {
			if (this.formData.idWhoChangedNavigationLogin) {
				return true;
			}
			return false;
		}

		//VaPTODO - vytvorit Base komponenetu na presmerovani na prisluny detail objektu, zatim natvrdo, ale jiz je to na nekolika mistech (detail prihlaseneho uzivatel, zde nekolikrat atd)
		/**když kliknu na uživatele*/
		detailUserPageWhoChangedClick() {
			this.goToUserPage(this.formData.idWhoChanged.toString());
		}

		detailUserPageWhoConfirmedClick() {
			this.goToUserPage(this.formData.idWhoConfirmed.toString());
		}

		goToUserPage(idUser: string) {
			this.$router.push({ name: "UserDetail", params: { id: idUser }, query: { id: idUser } });
		}

		/**když kliknu na zmenovy objekt*/
		goToObjectDetailClick() {
			let idObject: string = this.formData.idChangeObject.toString();
			let pagename: string = this.GetPageNameByObjetType(this.formData.idObjectTypeNavigationIdentifier);
			this.$router.push({ name: pagename, params: { id: idObject }, query: { id: idObject }  });
		}

		GetPageNameByObjetType(objectTypeIdentifier: string): string {
			switch (objectTypeIdentifier.toUpperCase()) {
				case "ENU_COR_CHANGELOG_OBJECTTYPE_PERSON": {
					return "PersonDetail";
				}
				case "ENU_COR_CHANGELOG_OBJECTTYPE_CONNECTION": {
					return "ConnectionDetail";
				}
				case "ENU_COR_CHANGELOG_OBJECTTYPE_WORKINGUNIT": {
					return "WorkingUnitDetail";
				}
				case "ENU_COR_CHANGELOG_OBJECTTYPE_OPERATIONALRECORD": {
					return "OperationalRecordDetail";
				}
				case "ENU_COR_CHANGELOG_OBJECTTYPE_CONTENT": {
					return "ContentDetail";
				}
				case "ENU_COR_CHANGELOG_OBJECTTYPE_TASK": {
					return "TaskDetail";
				}
				default: {
					return '';
				}
			}
		}
	}

